const KEY = "kocm_researcher_ack_v1";
const VERSION = 1;
const MAX_AGE_DAYS = 30;

export function readAck() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY));
    if (!raw || raw.policy_version !== VERSION) return null;
    const ts = new Date(raw.acknowledged_at).getTime();
    if (Date.now() - ts > MAX_AGE_DAYS * 86400000) return null;
    return raw;
  } catch { return null; }
}

export function saveAck({ institution }) {
  const ack = {
    policy_version: VERSION,
    institution: institution || "",
    acknowledged_at: new Date().toISOString(),
  };
  localStorage.setItem(KEY, JSON.stringify(ack));
  return ack;
}

export const ACK_VERSION = VERSION;
